module.exports = __webpack_public_path__ + "img/d3js.0ba3e913.png";